module.exports = __webpack_public_path__ + "img/bandicam_00010.773b7509.png";